import { render, staticRenderFns } from "./SpringSpinner.vue?vue&type=template&id=1ae1dc20&scoped=true&"
import script from "./SpringSpinner.vue?vue&type=script&lang=js&"
export * from "./SpringSpinner.vue?vue&type=script&lang=js&"
import style0 from "./SpringSpinner.vue?vue&type=style&index=0&id=1ae1dc20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae1dc20",
  null
  
)

export default component.exports